export default __webpack_public_path__ + "static/media/YAS0520.34I-27813_-16711_0.c6fe5cd5.jpg";